export default __webpack_public_path__ + "static/media/telegram.99e8f0f5.svg";